export default __webpack_public_path__ + "static/media/zhongxin.8c11fd12.png";